import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'

const baseURL = window.baseUrl

export const api = axios.create({
    // axios 的一些配置，baseURL  timeout
    baseURL: baseURL,
    timeout: 60000 * 3
})


// request interceptor
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('USER_TOKEN_STORAGE')
    
    if(JSON.stringify(token) === 'null') {
      localStorage.removeItem('USER_TOKEN_STORAGE');
      localStorage.removeItem('USER_INFO_STORAGE');
      localStorage.removeItem('MOBILENUM');

      if(router.history.current.meta.requireAuth) {
        return router.replace({
          path: '/login',
          query: {redirect: router.history.current.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
      }
    }
    config.headers.Authorization = `Bearer ${token}`
    

    if (typeof(config.params) !== 'undefined') {
      config.timeout = config.params.timeout || config.timeout
    }

    config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json;charset=UTF-8'
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
api.interceptors.response.use(
  response => {
    const data = response.data
    if(typeof(response.headers['refresh-token']) != 'undefined') {
      localStorage.setItem('USER_TOKEN_STORAGE', response.headers['refresh-token'])
    }
    if(typeof(response.config.resType) != 'undefined' && response.config.resType === 'blob') {
      let blob = data;
      const reader = new FileReader();
      reader.readAsDataURL(blob); // 转换为base64，可以直接放入a标签href
      reader.onload = e => {
          // 转换完成，创建一个a标签用于下载
          let a = document.createElement("a");
          a.style.display = "none";
          let fileName = decodeURI(response.headers['content-disposition'].split(';')[1].slice(9))
          a.download = fileName;
          a.href = e.target.result;
          const body = document.body;
          document.body.appendChild(a); // 修复firefox中无法触发click
          a.click();
          document.body.removeChild(a);
      };
      return false
    }
    const res = response.data
    // 统一鉴权登录拦截
    // if(Number(res.resultCode) === 401){
    //   window.location.href = res.loginUrl
    //   return
    // }
    // 导入文件成功会出现undefined的情况, 成功码默认200.
    if (Number(res.code) !== 0 && response.config.url!='/login/code') {      
      Message({ showClose: true, message: res.resultMessage || res.resultMsg || res.message || 'Error', type: 'error' })
      return Promise.reject(res)
    } else {
      return res
    }
  },
  error => {
    if(error.message.includes('401') && router.history.current.meta.requireAuth) {
      console.log(error);
      localStorage.removeItem('USER_TOKEN_STORAGE');
      localStorage.removeItem('USER_INFO_STORAGE');
      localStorage.removeItem('MOBILENUM');

      router.replace({
        path: '/login',
        query: {redirect: router.history.current.fullPath}
      })
      error.message = '登录超时，请重新登录'
    }else if(error.message.includes('Network Error')) {
      error.message = '网络超时，请检查网络'
    }
    
    // function getUrlParams(url) {
    //   // 通过 ? 分割获取后面的参数字符串
    //   let urlStr = url.split('?')[1]
    //   // 创建空对象存储参数
    //   let obj = {};
    //     // 再通过 & 将每一个参数单独分割出来
    //   let paramsArr = urlStr.split('&')
    //   for(let i = 0,len = paramsArr.length;i < len;i++){
    //         // 再通过 = 将每一个参数分割为 key:value 的形式
    //     let arr = paramsArr[i].split('=')
    //     obj[arr[0]] = arr[1];
    //   }
    //   return obj
    // }
    return Promise.reject(error)
  }
)

// 请求工具函数
export default (url, method, submitData) => {
    // 负责发请求：请求地址，请求方式，提交的数据
    return api({
      url,
      method,
      // 1. 如果是get请求  需要使用params来传递submitData   ?a=10&c=10
      // 2. 如果不是get请求  需要使用data来传递submitData   请求体传参
      // [] 设置一个动态的key, 写js表达式，js表达式的执行结果当作KEY
      // method参数：get,Get,GET  转换成小写再来判断
      // 在对象，['params']:submitData ===== params:submitData 这样理解
      [method.toLowerCase() === 'get' ? 'params' : 'data']: submitData
    })
}